import React from "react";
import { Route } from "react-router-dom";

const AppRoute = ({
  component: Component,
  layout: Layout,
  requireAuth: requireAuth,
  isLogin: isLogin,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      requireAuth && requireAuth();
      return (
        <Layout>
          <Component {...props} isLogin={isLogin} />
        </Layout>
      );
    }}
  />
);

export default AppRoute;
